"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localization_1 = require("../localization");
var fallbackLocale = 'en-US';
function getLocalizedString(locale, filename, key) {
    var localeData = localization_1.default[locale] || {};
    var fileData = localeData[filename] || {};
    if (fileData.hasOwnProperty(key)) {
        return fileData[key];
    }
    if (locale != fallbackLocale) {
        return getLocalizedString(fallbackLocale, filename, key);
    }
    return filename + "/" + key;
}
;
function parseLocale(input) {
    var match = /^([a-z]{2})-([A-Z]{2})$/i.exec(input);
    if (match) {
        var locale = match[1].toLowerCase() + "-" + match[2].toUpperCase();
        if (localization_1.default.hasOwnProperty(locale)) {
            return locale;
        }
    }
    return fallbackLocale;
}
exports.parseLocale = parseLocale;
exports.get = getLocalizedString;
